export function browserBack() {
  let lastHash = '';
  window.addEventListener('hashchange', () => {
    lastHash = window.location.hash;

    if (lastHash === '') {
      const last = window.location.href.split('/').pop();
      const url = window.location.href.replace(last, '');
      window.location.replace(url);
    }
  });
}
